module.exports = __webpack_public_path__ + "static/img/login_background.5bc6055a.svg";